import { isNullOrUndefined } from './is-null-or-undefined';

export interface Grouping<K, T> {
  key: K;
  items: T[];
};

export function group<K, T>(array: Iterable<T>, keyGetter: (item: T) => K,                  defaultKey?: K, sortGroupItems?: (a: T, b: T) => number): Grouping<K, T>[];
export function group<K, T>(array: Iterable<T>, keyName: string,                            defaultKey?: K, sortGroupItems?: (a: T, b: T) => number): Grouping<K, T>[];
export function group<K, T>(items: Iterable<T>, keyGetterOrName: ((item: T) => K) | string, defaultKey?: K, sortGroupItems?: (a: T, b: T) => number): Grouping<K, T>[] {
  let keyGetter: (item: T) => K;

  if (typeof keyGetterOrName == 'string') {
    keyGetter = item => <K>((<any>item)[keyGetterOrName]);
  }
  else {
    keyGetter = keyGetterOrName;
  }

  let groupMap = new Map<K, Grouping<K, T>>();

  for (let item of items) {
    let key = keyGetter(item);

    if (isNullOrUndefined(key) || (<unknown>key === ''))
      key = defaultKey;

    let grouping = groupMap.get(key); 

    if (!grouping) {
      grouping = { key, items: [] };

      groupMap.set(key, grouping);
    }

    grouping.items.push(item);
  }

  let result = Array.from(groupMap.values());

  if (sortGroupItems) {
    for (let g of result)
      g.items.sort(sortGroupItems);
  }

  return result;
}

export function groupToMap<K, T>(array: Iterable<T>, keyGetter: (item: T) => K,                  defaultKey?: K, sortGroupItems?: (a: T, b: T) => number): Map<K, T[]>;
export function groupToMap<K, T>(array: Iterable<T>, keyName: string,                            defaultKey?: K, sortGroupItems?: (a: T, b: T) => number): Map<K, T[]>;
export function groupToMap<K, T>(items: Iterable<T>, keyGetterOrName: ((item: T) => K) | string, defaultKey?: K, sortGroupItems?: (a: T, b: T) => number): Map<K, T[]> {
  let groups = group<K, T>(items, keyGetterOrName as any, defaultKey, sortGroupItems);
  return new Map(groups.map(x => [x.key, x.items]));
}
